import { Table, TableProps } from '@servicetitan/design-system';
import styled from 'styled-components';

interface DrawerTableProps extends TableProps {
  $height?: string;
}

export const DrawerTable = styled(Table)<DrawerTableProps>`
  height: ${({ $height }) => $height};

  // hide all decendants with classname k-grid-norecords
  .k-grid-norecords {
    display: none;
  }

  .k-grid-content {
    overflow-y: auto !important;
  }

  .k-pager-wrap {
    margin-top: auto;
  }
`;

type DrawerTableWrapperProps = {
  $flex?: number;
  $overflowHidden?: boolean;
};

export const DrawerTableWrapper = styled.div<DrawerTableWrapperProps>`
  position: relative;
  flex: ${({ $flex }) => $flex};
  overflow: ${({ $overflowHidden }) => ($overflowHidden ? 'hidden' : 'unset')};
`;

export const DrawerTableErrorWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
